import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { defaultHandleChange } from "../../utils/handler";
import { DEFAULT_CREDENTIALS } from "../../utils/state";
import { LoginForm } from "../../components/LoginForm";
import { Snackbar } from "../../components/Snackbar";
import { THEME_SEVERITY } from "../../utils/theme";
// import { STRINGS } from "../../utils/strings";
import { useMoodleV2 } from "../../contexts/moodle";
import {
  DEFAULT_SNACKBAR,
  ERROR_CREDENTIALS,
  ERROR_EMPTY_CREDENTIALS,
  SUCCESS_CREDENTIALS,
} from "../../utils/snackbar";

import { useTheme } from "../../contexts/ThemeContext";
import "./styles.css";
import { readableColor } from "polished";
import { useConfig } from "../../contexts/config";

const Login = () => {
  const { config } = useConfig();
  const theme = useTheme();
  const auth = useAuth();
  const navigate = useNavigate();
  const [credentials, setCredentials] = React.useState(DEFAULT_CREDENTIALS);
  const [loading, setLoading] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState(DEFAULT_SNACKBAR);
  const [contrastColorSecondary, setcontrastColorSecondary] =
    React.useState("green");
  const [contrastColorPrimary, setcontrastColorPrimary] = React.useState("red");
  const moodlev2 = useMoodleV2();

  React.useEffect(() => {
    //console.log(config);
    document.querySelector("#root").style.backgroundColor = "transparent";
    let bg_img = config.config.theme.background_login;
    document.body.classList.add("imagen2", "bigDesktop:bg-cover");
    // if (localStorage.getItem("token")) navigate("/listcourses");

    if (bg_img) {
      document.body.style.backgroundImage = `url(${bg_img})`;
    }
    return () => {
      document.body.style.backgroundImage = ``;
      document.body.classList.remove(
        "imagen2",
        "bg-auto",
        "bigDesktop:bg-cover"
      );
    };
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    //console.log(theme);
    if (theme && theme.colors.secondary) {
      setcontrastColorSecondary(
        readableColor(theme.colors.secondary_light, "#000", "#fff", false)
      );
    }
    if (theme && theme.colors.primary_light) {
      setcontrastColorPrimary(
        readableColor(theme.colors.primary_light, "#000", "#fff", false)
      );
    }
    // eslint-disable-next-line
  }, [theme]);

  React.useEffect(() => {
    auth.logout(moodlev2);
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    moodlev2.setPageEmbed(null);
  }, [moodlev2]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEmpty = Object.values(credentials).some((value) => value === "");
    if (isEmpty) {
      setSnackbar(ERROR_EMPTY_CREDENTIALS);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
      return;
    }
    let clean_username = credentials.username.replace(/\s/g, "").toLowerCase();
    try {
      setLoading(true);
      await auth.Login({ ...credentials, username: clean_username });
      setSnackbar(SUCCESS_CREDENTIALS);
      setTimeout(() => {
        setLoading(false);
        setSnackbar(DEFAULT_SNACKBAR);
        setCredentials(DEFAULT_CREDENTIALS);
        document.body.classList.remove("imagen3");
        navigate("/listcourses");
      }, 1000);
    } catch (error) {
      console.log(error.message);
      setSnackbar(ERROR_CREDENTIALS);
      setLoading(false);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
    }
  };

  const handleChange = (e) =>
    defaultHandleChange(e, credentials, setCredentials);

  return (
    <>
      <div className="container esp-log ">
        <img
          src="https://par.tuclase.cl/loginalt/images/logo2.png"
          alt="logo"
          className="posi-logo posi-log-b"
          style={{ visibility: "hidden" }}
        />
      </div>

      {theme.colors && theme.colors.themeLoaded && <div className="flex laptop:flex-row flex-col gap-[20%] items-center transition-all">
        <div
          style={{ backgroundColor: theme.colors.backgroundColorHeaderLogin ? theme.colors.backgroundColorHeaderLogin : "#000000" }}
          className=" flex flex-col w-[90%] tablet:w-[37rem] rounded-xl shadow-lg ml-[5%] tablet:ml-[15%] my-8 border-[1px] border-opacity-15 border-zinc-900"
        >
          <div
            style={{ backgroundColor: theme.colors.backgroundColorBodyLogin ? theme.colors.backgroundColorBodyLogin : "#000000" }}
            className="rounded-t-xl h-[19rem] flex flex-col items-center justify-center"
          >
            {config && config.titulo_interfaz && <h2 className="text-4xl font-semibold antialiased text-white tracking-wider pt-4">{config.titulo_interfaz}</h2>}
            <img
              className="logo-login py-8 "
              src={
                theme && theme.mode === "light"
                  ? config.config.theme.theme_logo_dark
                  : config.config.theme.theme_logo_dark
              }
              alt="..."
            />
          </div>
          <div className="p-8 space-y-8  rounded-lg shadow-md">
            <LoginForm
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              credentials={credentials}
              loading={loading}
              contrastColorSecondary={contrastColorSecondary}
              contrastColorPrimary={contrastColorPrimary}
              theme={theme}
              lang={auth.lang}
            />
          </div>
        </div>
        <div className="hidden laptop:block ml-[5%] tablet:ml-[15%] laptop:ml-0">
          <h1 className="llamado text-4xl tablet:text-5xl laptop:text-8xl">
            Experiencias de <br />
            aprendizaje
          </h1>
          <p className="llamado-d text-2xl tablet:text-3xl laptop:text-4xl">
            a la medida, actualizadas y efectivas
          </p>
        </div>
      </div>}

      <Snackbar
        severity={snackbar.severity}
        visible={snackbar.visible}
        message={snackbar.message}
      />
    </>
  );
};

export default Login;
